import http from '../APIs/olonaTeams'

export default class ClientAPI {
     // client
    public deleteClient = (user_id: string | number, client_id: string | number, token: any) => http.delete(`/client/${user_id}/${client_id}`, token)

    public getDetailClient = (id_client: string | number, token: any) => http.get(`/client/${id_client}`, token)

    public getClientProspects = (token: any) => http.get(`/clientprospects`, token)
  
    public getClientOk = (token: any) => http.get(`/clientOk`, token)

    public getClientNotOk = (token: any) => http.get(`/clientNotOk`, token)

    public createClient = (data: any, token: any) => http.post('/client', data, token)

    public updateClient = (id_client: string | number, data: any, token: any) => http.put(`/client/${id_client}`, data, token)

    public updateClientProspect = (id_client: string | number , data: any, token: any) => http.put(`/clientprospect/${id_client}`, data, token)

    public searchClient = (nom: string, token: any) => http.get(`/searchclient?nom=${nom}`, token)

    public searchClientProspect = (nom: string, token: any) => http.get(`/searchclientprospect?nom=${nom}`, token)

    public searchClientProspectbytitle = (nom: string, token: any) => http.get(`/searchclientprospectbytitle?nom=${nom}`, token)

    public searchClientProspectbyinterset = (data: any, token: any) => http.post(`/searchclientprospectbyinterest`,data, token)
  
  // suivi client
    public getSuiviClient = (id_client: string | number, token: any) => http.get(`/suiviclient/${id_client}`, token)

    public createSuiviClient = (data: any, token: any) => http.post(`/suiviclient`, data, token)
}